import { Skeleton } from '@mui/material'
import React from 'react'

const LoadingTableRows = ({isAdmin}) => {

    const dummyRows = new Array(10).fill(null);

    return (
        <>
            {
                dummyRows.map((row) => {
                    return <tr>
                    <td ><Skeleton variant='text' height={33}/></td>
                    <td><Skeleton variant='text' height={33}/></td>
                    <td><Skeleton variant='text' height={33}/></td>
                    <td>
                        <Skeleton variant='text' height={33}/>
                    </td>
                    <td><Skeleton variant='text' height={33}/></td>
                    <td><Skeleton variant='text' height={33}/></td>
                    <td>
                        <Skeleton variant='text' height={33}/>
                    </td>
                    <td className={`d-flex flex-wrap justify-content-center`}>
                        <Skeleton variant='text' sx={{width: '100%'}}  height={33}/>
                    </td>
                    {isAdmin && <>
                        <td className='text-center'>
                        <Skeleton variant='text'  height={33}/>
                        </td>
                        <td className='text-end'>
                            <Skeleton variant='text' height={33}/>
                        </td>
                    </>
                    }
                </tr>
            })
        }
        </>
    )
}

export default LoadingTableRows